import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { classNames } from "../models/models";

type LoaderProps = {
  className?: string;
};

const Loader = ({ className }: LoaderProps) => {
  return (
    <Box className={classNames("h-full flex items-center justify-center", className)}>
      <CircularProgress />
    </Box>
  );
};

export default Loader;
